export default function LowStockList({ products = [], onOpenProducts }) {
  return (
    <section className="admin-summary-panel" aria-labelledby="low-stock-heading">
      <header><div><h2 id="low-stock-heading">Low-stock attention</h2><p>Active products with five or fewer units.</p></div><button className="text-button" onClick={onOpenProducts} type="button">Manage inventory</button></header>
      {products.length ? <ul className="admin-low-stock">{products.map((product) => <li key={product._id}><div><strong>{product.displayName || product.name}</strong><small>{product.sku || 'No SKU'} · {product.status}</small></div><span>{product.stock} left</span></li>)}</ul> : <p className="admin-empty-state">No active products currently meet the low-stock threshold.</p>}
    </section>
  );
}
